/* eslint-disable arrow-parens */
import request from './request.js';

/**
 * @returns {Promise<unknown>}
 */
function refreshToken() {
    const options = {
        endpoint: `/auth/token/refresh`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function getWhiteLabel(hasAuth) {
    const options = {
        endpoint: hasAuth ? `/user/whitelabel/auth` : `/user/whitelabel`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<any>}
 */
function get() {
    const options = {
        endpoint: `/user/data?portal=web`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<any>}
 */
function getDependent() {
    const options = {
        endpoint: `/user/dependent/data?portal=web`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param role
 * @param email
 * @param token
 * @returns {Promise<unknown>}
 */
function verifyToken(role, email, token) {
    const options = {
        endpoint: '/auth/token/verify',
        method: 'POST',
        body: {
            role,
            email,
            token
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param {*} body
 */
function login(body) {
    const options = {
        endpoint: '/auth/login',
        method: 'POST',
        body: body,
        skipAuth: true
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param mfaCode
 * @param mfaSession
 * @param userID
 * @returns {Promise<unknown>}
 */
function submitMfaCode(mfaCode, mfaSession) {
    const options = {
        endpoint: `/auth/login/mfa`,
        method: 'POST',
        body: {
            mfaCode,
            mfaSession
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function sendForgotPasswordEmail(body) {
    const options = {
        endpoint: '/auth/sendForgotPasswordEmail',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param password
 * @param token
 * @returns {Promise<unknown>}
 */
function resetPassword(password, token) {
    const options = {
        endpoint: '/auth/resetPassword',
        method: 'POST',
        skipAuth: true,
        body: {
            password,
            token
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param password
 * @returns {Promise<unknown>}
 */
function createPassword(password) {
    const options = {
        endpoint: '/auth/createPassword',
        method: 'POST',
        body: {
            password
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function sendSupportEmail(body) {
    const options = {
        endpoint: '/user/sendSupportEmail',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function updateUserSettings(body) {
    const options = {
        endpoint: '/user/settings',
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @returns {Promise<any>}
 */
function saveBankingDetails(body) {
    const options = {
        endpoint: '/user/bankingDetails',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * 
 * @param {*} userID 
 * @returns 
 */
function getBankingDetails(userID) {
    const options = {
        endpoint: `/user/bankingDetails/${ userID }`,
        method: 'GET'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param existing
 * @param password
 * @param isDependent
 * @returns {Promise<any>}
 */
function changePassword(existing, password) {
    const options = {
        endpoint: '/user/password',
        method: 'PUT',
        body: {
            existing,
            password
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param {*} body
 */
function addDependent(body) {
    const options = {
        endpoint: '/user/dependents',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param {*} dependentID
 * @param {*} body
 */
function editDependent(dependentID, body) {
    const options = {
        endpoint: `/user/dependents/${ dependentID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param dependentID
 * @param password
 * @param signage
 * @returns {Promise<any>}
 */
function removeDependent(dependentID, password, signage) {
    const options = {
        endpoint: `/user/dependents/${ dependentID }`,
        method: 'DELETE',
        body: {
            password,
            signage
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param body
 * @param currentBeneficiaries
 * @returns {Promise<any>}
 */
function addBeneficiary(body, currentBeneficiaries) {
    const options = {
        endpoint: '/user/beneficiaries',
        method: 'POST',
        body: {
            ...body,
            primary: currentBeneficiaries.primary,
            contingent: currentBeneficiaries.contingent
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param beneficiaryID
 * @param body
 * @param currentBeneficiaries
 * @returns {Promise<any>}
 */
function editBeneficiary(beneficiaryID, body, currentBeneficiaries) {
    const options = {
        endpoint: `/user/beneficiaries/${ beneficiaryID }`,
        method: 'PUT',
        body: {
            ...body,
            primary: currentBeneficiaries.primary,
            contingent: currentBeneficiaries.contingent
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param beneficiaryID
 * @param password
 * @param currentBeneficiaries
 * @param signage
 * @returns {Promise<any>}
 */
function removeBeneficiary(beneficiaryID, password, currentBeneficiaries, signage) {
    const options = {
        endpoint: `/user/beneficiaries/${ beneficiaryID }`,
        method: 'DELETE',
        body: {
            password,
            primary: currentBeneficiaries.primary,
            contingent: currentBeneficiaries.contingent,
            signage
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param {*} body
 */
function addTrustee(body) {
    const options = {
        endpoint: '/user/trustee',
        method: 'POST',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param {*} trusteeID
 * @param {*} body
 */
function editTrustee(trusteeID, body) {
    const options = {
        endpoint: `/user/trustee/${ trusteeID }`,
        method: 'PUT',
        body
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param trusteeID
 * @param password
 * @param signage
 * @returns {Promise<any>}
 */
function removeTrustee(trusteeID, password, signage) {
    const options = {
        endpoint: `/user/trustee/${ trusteeID }`,
        method: 'DELETE',
        body: {
            password,
            signage
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param id
 * @returns {Promise<any>}
 */
function removeNotification(id) {
    const options = {
        endpoint: `/notifications/${ id }`,
        method: 'DELETE'
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @param date
 * @returns {Promise<unknown>}
 */
function getUsage(date = null) {
    const options = {
        endpoint: `/usage`,
        method: 'GET'
    };

    if (date) {
        options.endpoint = `/usage/${ date }`;
    }

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function initUpdateCreditCard() {
    const options = {
        endpoint: `/user/stripe/CC`,
        method: 'PUT',
        body: {}
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function finalizeCreditCardUpdate(checkoutSessionID) {
    const options = {
        endpoint: `/user/stripe/CC/update/finalize`,
        method: 'POST',
        body: {
            checkoutSessionID
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function downloadPDF(ComponentName, downloadParams) {
    const options = {
        endpoint: `/user/downloadPDF`,
        method: 'POST',
        body: {
            componentName: ComponentName,
            downloadParams
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 * @returns {Promise<unknown>}
 */
function refuseMarketplaceProduct(productID, password, signage) {
    const options = {
        endpoint: `/marketplace/${ productID }`,
        method: 'DELETE',
        body: {
            password,
            signage
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

/**
 *
 * @param institutionNum
 * @param transitNum
 * @returns {Promise<unknown>}
 */
function validateBankingDetails(institutionNum, transitNum) {
    const options = {
        endpoint: '/user/branchDetails/validate',
        method: 'POST',
        body: {
            institutionNum,
            transitNum
        }
    };

    return new Promise((resolve, reject) => {
        request(options)
            .then(resolve)
            .catch(reject);
    });
}

export {
    refreshToken,
    getWhiteLabel,
    get,
    getDependent,
    verifyToken,
    login,
    submitMfaCode,
    updateUserSettings,
    saveBankingDetails,
    sendForgotPasswordEmail,
    resetPassword,
    createPassword,
    sendSupportEmail,
    changePassword,
    addDependent,
    editDependent,
    removeDependent,
    addBeneficiary,
    editBeneficiary,
    removeBeneficiary,
    addTrustee,
    editTrustee,
    removeTrustee,
    removeNotification,
    getUsage,
    initUpdateCreditCard,
    finalizeCreditCardUpdate,
    downloadPDF,
    getBankingDetails,
    refuseMarketplaceProduct,
    validateBankingDetails
};